module.exports = __webpack_public_path__ + "img/buy-icon8.986332f.png";